<form [formGroup]="gammeForm" (ngSubmit)="addGamme()">
    <div class="form-container"> 
      <div class="form-field">
        <label>{{ 'referentiels.list.otpProperties.libelle.header'| transloco }}<span class="required">*</span></label>
        <input pInputText formControlName="designation" />
        <small class="p-error block">
          <p-message *ngIf="gammeForm.controls['designation'].invalid && gammeForm.controls['designation'].touched" severity="danger" text="Le champ pour la désignation est requis."></p-message>
        </small>
      </div>
    </div>
  
    <div class="button-container">
      <p-button pRipple label="{{ 'button.cancel' | transloco }}" [rounded]="true" (onClick)="close(false)" />
      <p-button pRipple label="{{ 'button.validate' | transloco}}" [rounded]="true" type="submit" [disabled]="gammeForm.invalid" />
    </div>
  
    <div *ngIf="submitting" class="loading-spinner">
      <p-progressSpinner [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
    </div>
  </form>
  <p-toast />
  